/**
 * The three "Paid in full" options, worded once (Dominique Genua, 2026-10-20). Option 3 takes its words from the UMED
 * board's own list (umedApi); options 1 and 2 keep Finance's wording.
 */
import { paidInFullOption } from '../umed/umedApi';
import type { FinanceCorrectionType } from './financeApi';

const UMED_CORRECTION = paidInFullOption('PAID_IN_FULL_CORRECTION');

export type PaidInFullOptionKey = 'close' | 'umed_pending' | 'correction';

export const PAID_IN_FULL_OPTIONS: { key: PaidInFullOptionKey; label: string; effect: string }[] = [
  { key: 'close', label: 'Paid in full', effect: 'Resident paid. No UMED needed. The case goes to Finance and closes.' },
  { key: 'umed_pending', label: 'Paid in full · UMED pending', effect: 'Resident paid. The UMED carries on through submission and approval; Finance is flagged.' },
  // Option 3 is UMED's correction act. Since 2026-10-21 Finance starts it from the dossier (PaidInFullCorrectionForm ->
  // POST /finance/residents/:id/umed-cases/:caseId/paid-in-full-correction) in the UMED board's own words, and links to the case.
  { key: 'correction', label: UMED_CORRECTION.label, effect: UMED_CORRECTION.effect },
];

/**
 * The two corrections Finance chooses between (Josie Evans, CORRECTIONS, 2026-10-28, R3 and R7), in her words. `what` is
 * when it applies; `effect` is what happens. The server maps the choice through the same two-entry allowlist.
 */
export const CORRECTION_TYPE_OPTIONS: { type: FinanceCorrectionType; label: string; what: string; effect: string; months: boolean }[] = [
  {
    type: 'SFS_CORRECTION',
    label: 'SFS correction',
    what: 'We are actively billing, but months are not reflecting or the monthly terms have an issue.',
    effect: 'It stays on the Finance side as well, and goes back to Gwynn to submit to DCF. The months you name read Correction until it is done.',
    months: true,
  },
  {
    type: 'PAID_IN_FULL_CORRECTION',
    label: 'Paid in full correction',
    what: 'Paid in full, but DCF may keep the UMED going, or a month changed after the facility paid.',
    effect: 'It stays on the Finance side as paid in full, and goes to Gwynn for correction. The Finance board does not change.',
    months: false,
  },
];
